export const formatPhoneNumber = (number: string) => {
	// Remove all non-digit characters
	const digits = number.replace(/\D/g, '');

	// Match the phone number with or without the leading '1'
	const match = digits.match(/^(1)?(\d{3})(\d{3})(\d{4})$/);

	if (match) {
		const countryCode = match[1] ? `+${match[1]} ` : '';
		return `${countryCode}${match[2]}-${match[3]}-${match[4]}`;
	}

	// Return the input unformatted if it doesn't match
	return number;
};
